import { render } from "./SpamNumberFormPage.vue?vue&type=template&id=bcdb1f28&ts=true"
import script from "./SpamNumberFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpamNumberFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/spam-number/SpamNumberFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcdb1f28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcdb1f28', __exports__)) {
    api.reload('bcdb1f28', __exports__)
  }
  
  module.hot.accept("./SpamNumberFormPage.vue?vue&type=template&id=bcdb1f28&ts=true", () => {
    api.rerender('bcdb1f28', render)
  })

}


export default __exports__